import { useState, useEffect, useCallback } from "react";
import { DatePicker, Popover, Select, Tabs, TimePicker } from "antd";
import images from "../../themes/appImage";
import { Table, Modal } from "antd";
import Textfiled from "../../common";
import {
  careListLoad,
  deleteCareLoad,
} from "../../redux/slices/directCare.slice";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../utils/global-func";
import moment from "moment";
import { imageURL } from "../../redux/Api/apikit";

const handleChange = (value) => {
  console.log(`selected ${value}`);
};

const DirectCare = () => {
  const dispatch = useDispatch();
  const [payload, setPayload] = useState({
    offset: 0,
    limit: 10,
    order: 1,
    search: "",
    type: "All",
    sort: "createdAt", // Default sort column
  });

  const [updateDateModal, setUpdateModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [id, setId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [modal1Open, setModal1Open] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const [currentPopOver, setCurrentPopOver] = useState(null);
  const [currentAllPopOver, setCurrentAllPopOver] = useState(null);
  const [currentTab, setCurrentTab] = useState(null);

  const { careList, carePagination, slotDashboard, isLoading } = useSelector(
    (state) => state.directCareReducer || {}
  );

  const handleCancilSubcription = () => {
    dispatch(
      deleteCareLoad({
        data: { slotId: id },
        payload,
        setCancelModal,
      })
    );
  };

  useEffect(() => {
    document.title = "MentalFit";
    dispatch(careListLoad({ ...payload, search: payload.search, offset: 0 }));
  }, [payload]);

  // Sort Handler
  const sortHandler = useCallback((sortKey) => {
    setPayload((prev) => ({
      ...prev,
      sort: sortKey,
      order: prev.order === 1 ? -1 : 1,
      offset: 0, // Reset to first page on sort
    }));
    setCurrentPage(1);
  }, []);

  const columns = [
    {
      title: "IDs",
      dataIndex: "srno",
      key: "srno",
      sorter: false, // ID column is typically not sorted
      render: (value, item, index) =>
        (carePagination?.currentPage - 1) * 10 + index + 1,
    },
    {
      title: "Participant",
      dataIndex: "participant",
      key: "participant",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div
          className="sort-icons"
          onClick={() => sortHandler("user.firstName")}
        >
          <span>Participant</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "user.firstName" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, item) => (
        <div className="organization-image-sec">
          <span>
            <img
              src={imageURL + item?.user?.avatar}
              className="h-5 w-5 object-cover"
            />
          </span>
          {item?.user?.firstName + " " + item?.user?.lastName}
        </div>
      ),
    },
    {
      title: "Therapist",
      dataIndex: "therapist",
      key: "therapist",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div
          className="sort-icons"
          onClick={() => sortHandler("pro.firstName")}
        >
          <span>Pro</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "pro.firstName" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, item) => (
        <div className="organization-image-sec">
          <span>
            <img
              src={imageURL + item?.pro?.avatar}
              className="h-5 w-5 object-cover"
            />
          </span>
          {item?.pro?.firstName + " " + item?.pro?.lastName}
        </div>
      ),
    },
    {
      title: "Date & Time",
      dataIndex: "date",
      key: "date",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div className="sort-icons" onClick={() => sortHandler("date")}>
          <span>Date & Time</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "date" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, item) => (
        <div className="table-tb-plan">
          {moment.utc(item?.date).format("MMMM D, YYYY")}{" "}
          <p>
            {moment.utc(item?.slotTime?.from).format("hh:mm A")} -
            {moment.utc(item?.slotTime?.to).format("hh:mm A")}
          </p>
        </div>
      ),
    },
    {
      title: "Amount",
      dataIndex: "price",
      key: "price",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div className="sort-icons" onClick={() => sortHandler("price")}>
          <span>Amount</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "price" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div className="sort-icons" onClick={() => sortHandler("status")}>
          <span>Status</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "status" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, item) => (
        <div className="status-active  ">
          <span>Upcoming</span>
        </div>
      ),
    },
    {
      title: "Ratings",
      dataIndex: "ratings",
      key: "ratings",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div className="sort-icons" onClick={() => sortHandler("rating")}>
          <span>Ratings</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "rating" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, item) => (
        <div className="organization-image-sec remove-the-gap">
          <span>
            {item?.rating ? (
              <div className="flex items-center gap-1">
                <img
                  src={images.starFill}
                  alt="star"
                  className="w-4 h-4 inline-block mx-0.5 align-middle"
                />
                {4.5}
              </div>
            ) : (
              "--"
            )}
          </span>
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "Posted",
      key: "Posted",
      render: (value, item, index) => (
        <div className="action-dots-iocn">
          <Popover
            content={
              <div className="popup" style={{ width: "200px" }}>
                <div
                  className="edit-account"
                  onClick={() => {
                    setCancelModal(true);
                    setId(item?._id);
                  }}
                >
                  <p>
                    <span>
                      <img src={images.crossSquar} alt="crossSquar" />
                    </span>
                    Cancel Session
                  </p>
                </div>
              </div>
            }
            title=""
            trigger="click"
            placement="bottomLeft"
            overlayClassName="update-popup"
            open={currentPopOver === index}
            onOpenChange={(e) =>
              !e ? setCurrentPopOver(null) : setCurrentPopOver(index)
            }
          >
            <span>
              <img
                src={images.horizontalDots}
                onClick={() => setCurrentPopOver(index)}
              />
            </span>
          </Popover>
        </div>
      ),
    },
  ];

  const columns2 = [
    {
      title: "ID",
      dataIndex: "srno",
      key: "srno",
      sorter: false,
      render: (value, item, index) =>
        (carePagination?.currentPage - 1) * 10 + index + 1,
    },
    {
      title: "Participant",
      dataIndex: "participant",
      key: "participant",

      sortDirections: ["ascend", "descend"],
      title: () => (
        <div
          className="sort-icons"
          onClick={() => sortHandler("user.firstName")}
        >
          <span>Participant</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "user.firstName" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, item) => (
        <div
          onClick={() => setModal2Open(true)}
          className="organization-image-sec popup-partic"
        >
          <span>
            <img
              src={imageURL + item?.user?.avatar}
              className="h-5 w-5 object-cover"
            />
          </span>
          {item?.user?.firstName + " " + item?.user?.lastName}
        </div>
      ),
    },
    {
      title: "Therapist",
      dataIndex: "therapist",
      key: "therapist",

      sortDirections: ["ascend", "descend"],
      title: () => (
        <div
          className="sort-icons"
          onClick={() => sortHandler("pro.firstName")}
        >
          <span>Pro</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "pro.firstName" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, item) => (
        <div className="organization-image-sec">
          <span>
            <img
              src={imageURL + item?.pro?.avatar}
              className="h-5 w-5 object-cover"
            />
          </span>
          {item?.pro?.firstName + " " + item?.pro?.lastName}
        </div>
      ),
    },
    {
      title: "Date & Time",
      dataIndex: "date",
      key: "date",
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div className="sort-icons" onClick={() => sortHandler("date")}>
          <span>Date & Time</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "date" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, record) => (
        <div className="table-tb-plan">
          {moment.utc(record?.date).format("MMMM D, YYYY")}{" "}
          <p>
            {moment.utc(record?.startTime).format("hh:mm A")} -
            {moment.utc(record?.endTime).format("hh:mm A")}
          </p>
        </div>
      ),
    },
    {
      title: "Amount",
      dataIndex: "price",
      key: "price",
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div className="sort-icons" onClick={() => sortHandler("price")}>
          <span>Amount</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "price" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div className="sort-icons" onClick={() => sortHandler("status")}>
          <span>Status</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "status" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, item) => (
        <div className={`status-active ${item?.status?.toLowerCase()}`}>
          <span className="capitalize">{item?.status}</span>
        </div>
      ),
    },
    {
      title: "Ratings",
      dataIndex: "ratings",
      key: "ratings",
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div className="sort-icons" onClick={() => sortHandler("rating")}>
          <span>Ratings</span>
          <img
            src={images.arrowLeft}
            alt=""
            style={{
              transform:
                payload.sort === "rating" && payload.order === -1
                  ? "rotate(180deg)"
                  : "none",
            }}
          />
        </div>
      ),
      render: (value, item) => (
        <div className="organization-image-sec remove-the-gap">
          <span>
            {item?.rating ? (
              <div className="flex items-center gap-1">
                <img
                  src={images.starFill}
                  alt="star"
                  className="w-4 h-4 inline-block mx-0.5 align-middle"
                />
                {4.5}
              </div>
            ) : (
              "--"
            )}
          </span>
        </div>
      ),
    },
  ];

  const onChangePage = (page) => {
    if (
      page < 1 ||
      (carePagination &&
        page > Math.ceil(carePagination.totalCount / payload.limit))
    )
      return;
    setCurrentPage(page);
    setPayload((prev) => ({
      ...prev,
      offset: (page - 1) * prev.limit,
    }));
  };

  const onChangePageSize = (limit) => {
    setPayload((prev) => ({
      ...prev,
      limit: Number(limit),
      offset: 0,
    }));
    setCurrentPage(1);
  };

  const TableFooter = () => {
    const totalCount = carePagination?.totalCount || 0;
    const from = totalCount === 0 ? 0 : (currentPage - 1) * payload.limit + 1;
    const to = Math.min(currentPage * payload.limit, totalCount);
    const totalPages = Math.ceil(totalCount / payload.limit);

    return (
      <div className="footer-section">
        <div className="foot-main-div">
          <div className="rows">
            <div className="row-per-page">
              <p>Rows per page</p>
            </div>
            <div className="top-checkbox fot-select">
              <Select
                value={String(payload.limit)}
                onChange={onChangePageSize}
                options={[
                  { value: "10", label: "10" },
                  { value: "15", label: "15" },
                  { value: "20", label: "20" },
                  { value: "25", label: "25" },
                ]}
              />
            </div>
          </div>
          <div className="page-count">
            <p>
              {from}-{to} of {totalCount}
            </p>
          </div>
          <div className="back-and-next">
            <span
              onClick={() => onChangePage(1)}
              style={{
                cursor: currentPage > 1 ? "pointer" : "not-allowed",
                opacity: currentPage > 1 ? 1 : 0.5,
              }}
            >
              <img src={images.next} className="rotate-180" alt="back" />
            </span>
            <span
              onClick={() => onChangePage(currentPage - 1)}
              style={{
                cursor: currentPage > 1 ? "pointer" : "not-allowed",
                opacity: currentPage > 1 ? 1 : 0.5,
              }}
            >
              <img src={images.new} className="rotate-180" alt="previous" />
            </span>
            <span
              onClick={() => onChangePage(currentPage + 1)}
              style={{
                cursor: currentPage < totalPages ? "pointer" : "not-allowed",
                opacity: currentPage < totalPages ? 1 : 0.5,
              }}
            >
              <img src={images.new} alt="next" />
            </span>
            <span
              onClick={() => onChangePage(totalPages)}
              style={{
                cursor: currentPage < totalPages ? "pointer" : "not-allowed",
                opacity: currentPage < totalPages ? 1 : 0.5,
              }}
            >
              <img src={images.next} alt="last" />
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="site-layout-background" style={{ minHeight: 360 }}>
        <div className="top-header-organi-zations">
          <div className="organi-zations-heading-text">
            <h1>Bookings</h1>
            <p>
              Sed consectetur imperdiet facilisiulla malesua daeddiet
              facilisiulla
            </p>
          </div>
        </div>

        <div className="total-user inner-circle-grid">
          <div className="user-count number-inner-cricle-ps">
            <p>Total Sessions</p>
            <h1>{slotDashboard?.totalSession}</h1>
          </div>
          <div className="user-count number-inner-cricle-ps">
            <p>Upcoming Sessions</p>
            <h1>{slotDashboard?.upcomingSession}</h1>
          </div>
          <div className="user-count number-inner-cricle-ps">
            <p>Pending Sessions</p>
            <div className="post-active-flex">
              <h1>{slotDashboard?.pendingSession}</h1>
            </div>
          </div>
          <div className="user-count number-inner-cricle-ps">
            <p>Cancelled Sessions </p>
            <div className="post-active-flex">
              <h1>{slotDashboard?.cancelSession}</h1>
            </div>
          </div>
        </div>

        <div className=" ">
          <div className="slider-tab-div slider-section profile-page-tab  ">
            <div className="tab-bar">
              <Tabs
                onChange={(e) => {
                  setCurrentTab(e);
                  setPayload((prev) => ({
                    ...prev,
                    type: e === "1" ? "all" : e === "2" ? "upcoming" : "past",
                    offset: 0,
                    search: "",
                    sort: "createdAt", // Reset sort on tab change
                    order: 1, // Reset order on tab change
                  }));
                  setSearchValue("");
                  setCurrentPage(1);
                }}
              >
                <Tabs.TabPane tab="All" key="1">
                  <div className="  ">
                    <div className="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 system-line">
                      <input
                        type="text"
                        className="iocn-search  search-bar"
                        placeholder="Search"
                        value={searchValue}
                        onChange={(e) => {
                          setSearchValue(e.target.value.trimStart());
                          debounce(
                            () =>
                              setPayload({
                                ...payload,
                                search: e.target.value,
                                offset: 0,
                              }),
                            400
                          );
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                    <Table
                      dataSource={careList}
                      columns={columns2}
                      showSorterTooltip={false}
                      pagination={{ pageSize: payload.limit }}
                      loading={isLoading}
                    />
                    <TableFooter />
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Upcoming" key="2">
                  <div className="">
                    <div className="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 system-line">
                      <input
                        type="text"
                        className="iocn-search  search-bar"
                        placeholder="Search"
                        value={searchValue}
                        onChange={(e) => {
                          setSearchValue(e.target.value.trimStart());
                          debounce(
                            () =>
                              setPayload({
                                ...payload,
                                search: e.target.value,
                                offset: 0,
                              }),
                            400
                          );
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                    <Table
                      dataSource={careList}
                      columns={columns}
                      showSorterTooltip={false}
                      loading={isLoading}
                      pagination={{ pageSize: payload.limit }}
                    />
                    <TableFooter />
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Past" key="3">
                  <div className="">
                    <div className="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 system-line">
                      <input
                        type="text"
                        className="iocn-search  search-bar"
                        placeholder="Search"
                        value={searchValue}
                        onChange={(e) => {
                          setSearchValue(e.target.value.trimStart());
                          debounce(
                            () =>
                              setPayload({
                                ...payload,
                                search: e.target.value,
                                offset: 0,
                              }),
                            400
                          );
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                    <Table
                      dataSource={careList}
                      columns={columns2}
                      showSorterTooltip={false}
                      pagination={{ pageSize: payload.limit }}
                      loading={isLoading}
                    />
                    <TableFooter />
                  </div>
                </Tabs.TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </div>

      {/* Manage Direct Care Questions */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal1Open}
        closable={true}
        onCancel={() => setModal1Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Manage Direct Care Questions</h1>
          </div>
          <div className="description-inner-circle">
            <div className="wrapper_line  manage-the-hight">
              <div className="form-group">
                <label>What is your Age?</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter text here"
                />
              </div>
              <div className="form-group">
                <label>What is your Relationship status?</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter text here"
                />
              </div>
              <div className="relationship">
                <p>
                  Single
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  Single
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
              </div>
              <div className="form-group">
                <label>Have you ever been in a therapy before?</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter text here"
                />
              </div>
              <div className="relationship">
                <p>
                  Yes
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  No
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
              </div>
              <div className="form-group">
                <label>What led you to consider therapy today?</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter text here"
                />
              </div>
              <div className="relationship">
                <p>
                  I've been feeling depressed.
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  I feel anxious or overwhelmed.
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  My mood is interfering with my job/school performance.
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  I am grieving.
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  I have experienced trauma.
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  I need to talk through a specific challenge.
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
              </div>
              <div className="form-group">
                <label>What are your expectations from Therapist?</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter text here"
                />
              </div>
              <div className="relationship">
                <p>
                  Listen
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  Explores my past
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  Teaches me new skills
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  Challenges my bliefs
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  Assign me homework
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  Guides me to set goals
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
              </div>
              <div className="form-group">
                <label>How would you rate your physical health</label>
                <Textfiled
                  className="form-control"
                  type="text"
                  placeholder="Enter text here"
                />
              </div>
              <div className="relationship">
                <p>
                  Good
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  Fair
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
                <p>
                  Poor
                  <span>
                    <img src={images.singleCross} alt="singleCross" />
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="click-to-upload add-widget">
            <div className="new-question">
              <p>
                <span>
                  <img src={images.add} alt="singleCross" />
                </span>
                Add New Question
              </p>
            </div>
            <div className="btn-schedule ">
              <button>Add Widget</button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Session Summary */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal2Open}
        closable={true}
        onCancel={() => setModal2Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Session Summary</h1>
          </div>
          <div className="session-sum">
            <div className="part-black">
              <div className="participant">
                <p>Participant</p>
              </div>
              <div className="ann-black">
                <p>
                  <span>
                    <img src={images.maleTable} />
                  </span>
                  Annette Black
                </p>
              </div>
            </div>
            <div className="part-black">
              <div className="participant">
                <p>Pro</p>
              </div>
              <div className="ann-black">
                <p>
                  <span>
                    <img src={images.maleTable} />
                  </span>
                  Robert_henry05
                </p>
              </div>
            </div>
            <div className="part-black">
              <div className="participant">
                <p>Date</p>
              </div>
              <div className="ann-black">
                <p>March 12, 2024 </p>
              </div>
            </div>
            <div className="part-black">
              <div className="participant">
                <p>Time</p>
              </div>
              <div className="ann-black">
                <p>10:00 PM - 10:30 PM</p>
              </div>
            </div>
            <div className="part-black">
              <div className="participant">
                <p>Waiting Time</p>
              </div>
              <div className="ann-black">
                <p>45s</p>
              </div>
            </div>
            <div className="part-black">
              <div className="participant">
                <p>Call Duration</p>
              </div>
              <div className="ann-black">
                <p>15 min</p>
              </div>
            </div>
            <div className="part-black">
              <div className="participant">
                <p>Rating</p>
              </div>
              <div className="ann-black less-gap-ann">
                <p>
                  <span>
                    <img src={images.pinkStar} />
                  </span>{" "}
                  4.9
                </p>
              </div>
            </div>
            <div className="part-black">
              <div className="participant">
                <p>Amount</p>
              </div>
              <div className="ann-black last-amount">
                <p>$50</p>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* Date and Time Modal */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={updateDateModal}
        closable={true}
        onCancel={() => setUpdateModal(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Date and Time</h1>
          </div>
          <div>
            <div className="m-5">
              <label className="font-semibold">Date:</label>
              <DatePicker
                className="updateModal"
                allowClear={false}
                placeholder="Select Date"
                bordered={false}
                onChange={(date, dateString) => console.log(dateString)}
              />
            </div>
            <div className="m-5">
              <label className="font-semibold">Time:</label>
              <TimePicker className="updateModal" />
            </div>
            <div className="click-to-upload">
              <div className="create-inner-circle-btn save-btn-mo">
                <button type="submit">Update</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* Cancel Modal */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={cancelModal}
        closable={true}
        onCancel={() => setCancelModal(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user modal-top-space-ps">
            <h1>Do you surely want to cancel this slot?</h1>
          </div>
          <div className="schedule-send-now">
            <div className="send-now option-no1">
              <button onClick={() => setCancelModal(false)}>NO</button>
            </div>
            <div className="btn-schedule">
              <button onClick={handleCancilSubcription}>YES</button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DirectCare;
